module.exports = __webpack_public_path__ + "static/media/7.1.bf38b352.png";